'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useViewportHeight = () => {
  const $ = _c(2);
  const [pageHeight, setPageHeight] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setPageHeight(window.innerHeight || document.documentElement.clientHeight);
      const handleResize = () => {
        setTimeout(() => {
          setPageHeight(window.innerHeight || document.documentElement.clientHeight);
        });
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return pageHeight;
};